"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hopperTypes = void 0;
exports.hopperTypes = {
    SET_LOADING: 'HOPPER TYPES SET LOADING',
    SET_ERROR: 'HOPPER TYPES REDUCER SET ERROR',
    SET_DATA_GRID: 'HOPPER TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'HOPPER TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'HOPPER TYPES ON MUTATION',
    ON_SORT_CHANGE: 'HOPPER TYPES ON SORT CHANGE',
    ON_SAVE_DATAITEM: 'HOPPER TYPES ON SAVE DATAITEM',
    ON_FILTER_CHANGE: 'HOPPER TYPES ON FILTER CHANGE',
    ON_DELETE_DATAITEM: 'HOPPER TYPES ON DELETE DATAITEM',
    ON_CHANGE_DATAITEM: 'HOPPER TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'HOPPER TYPES SET SUCCESS MODAL',
    SET_DATA_ENUM_HOPPER: 'HOPPER TYPES GET DATA ENUM HOPPER',
};
